@if (hasActions()) {
  <div class="client-messenger-actions" [class.client-messenger-actions--compact]="compact()">
    @if (showTel()) {
      <a
        class="client-messenger-actions__button"
        [href]="'tel:' + phone()"
        (click)="$event.stopPropagation()"
        [attr.aria-label]="'admin.users.messengers.call' | translate"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
    }

    @for (action of actions(); track action.type) {
      <a
        class="client-messenger-actions__button"
        [href]="action.href"
        target="_blank"
        rel="noopener"
        (click)="$event.stopPropagation()"
        [attr.aria-label]="action.labelKey | translate"
      >
        <img [src]="action.iconSrc" alt="" width="20" height="20" />
      </a>
    }
  </div>
}
